import React, { Component } from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

class Filter extends Component {

    styles = {
        wrapper: {
            display: 'grid',
            gridTemplateColumns: 'auto auto auto auto'
        }
    };
    onFilterSelected = (event, value) => {
        if (value === 'all') {
            this.props.store.dispatch({type: 'SET_TERM', term: ''});
        } else {
            this.props.store.dispatch({type: 'SET_TERM', term: value});
        }
        window.ga('send', 'event', 'Filters', 'click', value);
    };

    render() {
        return (
            <MuiThemeProvider>
            <div>
            <RadioButtonGroup style={this.styles.wrapper} name="filterOptions" defaultSelected="all" id="filter-list" onChange={this.onFilterSelected}>
                <RadioButton
                    value="all"
                    label="All"
                />
                <RadioButton
                    value="designer"
                    label="Designer"
                />
                <RadioButton
                    value="developer"
                    label="Developer"
                />
                <RadioButton
                    value="engineer"
                    label="Engineer"
                />
                <RadioButton
                    value="marketing"
                    label="Marketer"
                />
                <RadioButton
                    value="programmer"
                    label="Programmer"
                />
                <RadioButton
                    value="ceo"
                    label="CEO"
                />
                <RadioButton
                    value="graphics"
                    label="Graphics"
                />
            </RadioButtonGroup>
            </div>
        </MuiThemeProvider>
        );
    }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/Filter.js